import React from 'react';

const REPORTS = [
  { key: 'reports-stock-list', icon: '📋', title: 'Stok Listesi', desc: 'Tablolu stok dökümü — depo bazlı miktarlar, filtre, Excel/PDF/yazdır + çoklu şablon.' },
  { key: 'stock-labels', icon: '🏷', title: 'Barkod Etiket Dökümü', desc: 'Tasarladığınız şablon ile stoklara barkod/fiyat etiketi yazdırın.' },
  { key: 'label-templates', icon: '🎨', title: 'Etiket Şablonları', desc: 'Etiket tasarımları (kağıt, ölçü, alanlar) — yeni oluştur veya düzenle.' },
  // Diğer raporlar yakında
];

export default function StockReportsHub({ onNavigate }) {
  return (
    <div style={{ padding: 24, maxWidth: 1100, margin: '0 auto' }}>
      <h1 style={{ fontSize: '1.4rem', fontWeight: 700, marginBottom: 8 }}>Stok Raporları</h1>
      <p style={{ color: 'var(--text-secondary)', fontSize: '0.88rem', marginBottom: 20 }}>
        Stok bazlı dökümler ve etiket tasarımı.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 }}>
        {REPORTS.map(r => (
          <button
            key={r.key}
            onClick={() => onNavigate && onNavigate(r.key)}
            style={{
              textAlign: 'left',
              padding: 18,
              background: 'var(--bg-card)',
              border: '1px solid var(--border-secondary)',
              borderRadius: 12,
              cursor: 'pointer',
              transition: 'transform 0.12s, border-color 0.12s',
              color: 'var(--text-primary)',
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent-primary, #3b82f6)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border-secondary)'; e.currentTarget.style.transform = 'none'; }}
          >
            <div style={{ fontSize: '1.8rem', marginBottom: 8 }}>{r.icon}</div>
            <div style={{ fontWeight: 700, fontSize: '0.98rem', marginBottom: 4 }}>{r.title}</div>
            <div style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', lineHeight: 1.4 }}>{r.desc}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
